document.addEventListener('DOMContentLoaded', () => {
    const faqItems    = document.querySelectorAll('.faq-item');
    let   openAnswer  = null;
    let   openQuestion = null;

    faqItems.forEach(item => {
        const question = item.querySelector('.faq-question');
        const answer   = item.querySelector('.faq-answer');

        question.addEventListener('click', () => {
            // 1) If a different answer is open, close it and deactivate its question
            if (openAnswer && openAnswer !== answer) {
                openAnswer.style.maxHeight = '';
                openQuestion.classList.remove('active');
                openAnswer  = null;
                openQuestion = null;
            }

            // 2) Toggle this one
            if (answer.style.maxHeight) {
                // → currently open: close it
                answer.style.maxHeight = '';
                question.classList.remove('active');
                openAnswer  = null;
                openQuestion = null;
            } else {
                // → currently closed: open it
                answer.style.maxHeight = answer.scrollHeight + 'px';
                question.classList.add('active');
                openAnswer   = answer;
                openQuestion = question;
            }
        });
    });

    // On resize, recompute height of the single open answer (so it still fits)
    window.addEventListener('resize', () => {
        if (openAnswer) {
            openAnswer.style.maxHeight = openAnswer.scrollHeight + 'px';
        }
    });
});
